import createTransactionCompsData from 'pages/ValuationsAllocation/approaches/TransactionComps/config/createTransactionCompsData';
import TransactionComps from 'pages/ValuationsAllocation/approaches/TransactionComps/TransactionComps';
import { getApproachTableName } from 'pages/ValuationsAllocation/util';
import { getStringValue } from 'utilities';
import createPerformanceMetrics from './PerformanceMetrics/createPerformanceMetricsConfig';
import { CreateTransactionCompsConfigParams } from './types';

const createTransactionCompsConfig = (params: CreateTransactionCompsConfigParams) => {
  const {
    approach,
    companyInfo,
    financials,
    format,
    compGroups,
    transactionCompsAttributes,
    isDisabled,
    gpcApproaches,
    gpcOptions,
  } = params;
  const name = getApproachTableName({ approach });

  const compsSheet = createTransactionCompsData({
    approach,
    name,
    companyInfo,
    financials,
    format,
    compGroups,
    transactionCompsAttributes,
    isDisabled,
    gpcApproaches,
    gpcOptions,
  });

  const performanceMetricsSheet = createPerformanceMetrics({
    approach,
    financials,
    companyName: getStringValue(companyInfo?.name),
  });

  return {
    name,
    approach,
    spreadsheets: {
      compsSheet,
      performanceMetricsSheet,
    },
    enterpriseValueReference: name,
    value: approach.enterprise_value,
    component: TransactionComps,
    financials,
  };
};

export default createTransactionCompsConfig;
